import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from "../../../../StatusBadge";

ProductStatusBadge.propTypes = {
    status: PropTypes.bool.isRequired
};

function ProductStatusBadge({status, ...props}) {
    return <StatusBadge status={status} />
}

export default ProductStatusBadge;
